import React from "react";

import { Icons } from "components";

import * as S from "./styles";

export type DividerProps = {
  title?: string;
};

export const Divider = ({ title }: DividerProps) => {
  return (
    <S.Container>
      <S.Icon>
        <Icons.Ionicons name="information-circle" />
      </S.Icon>

      {!!title && <S.Title>{title}</S.Title>}
      <S.Line />
    </S.Container>
  );
};
